export const OutputDocumentTemplateType = {
	load_doc_template: 1,
	unload_doc_template: 2,
}

export const InvoiceDocumentTemplateType = {
	invoice_template: 3
}

export const DefaultDocumentTemplateType = {
	...OutputDocumentTemplateType,
	...InvoiceDocumentTemplateType
}

export const DefaultDocumentTemplateWithNullTerminal = {
	...InvoiceDocumentTemplateType
}
